import { getMaxTokenLength } from '@atlassian/jira-issue-fetch-services-common/src/common/utils/token-browser-utils.tsx';

// This is set to 100 as that is the max limit for the query to get media read tokens
export const MAX_BATCH_SIZE = 100;
export const MAX_TOKEN_LENGTH = getMaxTokenLength();
